import DashboardNav from "../components/DashboardNav/DashboardNav";
import PaymentFail from "../components/PaymentFail/PaymentFail";
import PaymentSuccess from "../components/PaymentSuccess/PaymentSuccess";
import { useLocation } from "react-router-dom";

const PaymentPage = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[3];

  return (
    <div className="qrcodepage">
      <div className="dahsboard__menu">
        <DashboardNav />
      </div>
      <div className="qrcodepage__container">
        {id === "success" ? <PaymentSuccess /> : <PaymentFail />}

        <PaymentFail />
      </div>
    </div>
  );
};

export default PaymentPage;
